import createRoutine from '@/utils/createRoutine'

export const cashFlowRoutine = createRoutine('cashFlowRoutine')
export const cashFlowForecastRoutine = createRoutine('cashflowForecastRoutine')
export const cashflowForecastCleanupRoutine = createRoutine('cashflowForecastCleanupRoutine')

export const cashFlowGetters = {
  CASH_FLOW_DETAILS: 'CASH_FLOW_DETAILS',
  CASH_FLOW_DETAILS_ERROR: 'CASH_FLOW_DETAILS_ERROR',
  CASH_FLOW_FORECAST: 'CASH_FLOW_FORECAST'
}

export const CASH_FLOW_DETAILS_CLEANUP = 'CASH_FLOW_DETAILS_CLEANUP'
export const CASH_FLOW_FORECAST_CLEANUP = 'CASH_FLOW_FORECAST_CLEANUP'
